<template>
  <div class="EmailListInput">
    <div class="left">
      <ValidationObserver ref="validation" v-slot="{ invalid }">
        <FormLayout>
          <ValidationProvider :name="label" rules="email" v-slot="{ errors }">
            <TextField
              v-model.trim="newEmail"
              @keydown.enter="add"
              :placeholder="$t('Email Address')"
              :label="label"
              :error="error || errors[0]"
              :readonly="readonly"
            >
              <template #right>
                <Button type="primary" @click="add" :disabled="invalid || !newEmail || readonly">{{$t('Add')}}</Button>
              </template>
            </TextField>
          </ValidationProvider>
        </FormLayout>
      </ValidationObserver>
    </div>
    <div class="right">
      <div class="EmailListInput-list">
        <ul>
          <li v-for="email of internalEmails" :key="email"><Button @click="remove(email)" type="plain"><Icon icon="fas fa-times-circle" /></Button> {{ email }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailListInput',
  props: {
    emails: {
      type: [String, Array]
    },
    label: {
      type: String
    },
    error: {
      type: String
    },
    readonly: {
      type: Boolean
    },
    addSurroundingQuotes: {
      type: Boolean,
      default: false
    },
    arrayMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newEmail: '',
      internalEmails: []
    }
  },
  mounted() {
    if (this.arrayMode) {
      this.internalEmails = this.emails || []
    } else {
      this.internalEmails = this.emails ? this.emails.replace(/^"/, '').replace(/"$/, '').split(',') : []
    }
  },
  methods: {
    emitUpdate() {
      if (this.arrayMode) {
        this.$emit('update:emails', this.internalEmails)
      } else {
        if (this.addSurroundingQuotes) {
          this.$emit('update:emails', `"${this.internalEmails.join(',')}"`)
        } else {
          this.$emit('update:emails', `${this.internalEmails.join(',')}`)
        }
      }
    },
    async add() {
      if (!await this.$refs.validation.validate()) {
        return
      }
      const newEmail = this.newEmail.trim()
      if (newEmail && !this.internalEmails.includes(newEmail)) {
        this.internalEmails.push(newEmail)
        this.emitUpdate()
      }
      this.newEmail = ''
    },
    remove(email) {
      this.internalEmails.splice(this.internalEmails.indexOf(email), 1)
      this.emitUpdate()
    }
  }
}
</script>

<style scoped>
  .EmailListInput {
    display: flex;
    flex-wrap: wrap;
  }
  .left {
    margin-right: 15px;
    flex: 1 1 200px;
  }
  .right {
    flex: 1 1 200px;
    margin-top: 15px;
  }
</style>